import MenuIcon from '@mui/icons-material/Menu'
import { Backdrop, Box, Typography } from '@mui/material'
import { Button } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { HomepageLogo } from '..'
import type { WhoAmIPermissions } from '../../../../../types'
import sharedStyles from '../../HeaderNavigation.module.scss'
import MobileNavMenu from './MobileNavMenu'
import styles from './MobileNavigation.module.scss'

interface MobileNavigationProps {
  userPermissions: WhoAmIPermissions | null
}

export const MobileNavigation = ({
  userPermissions,
}: MobileNavigationProps) => {
  const [navMenuOpen, setNavMenuOpen] = useState(false)

  return (
    <>
      <MobileNavigationHeader onNavMenuClick={() => setNavMenuOpen(true)} />
      <Box>
        <Backdrop
          open={navMenuOpen}
          onClick={() => {
            setNavMenuOpen(false)
          }}
        />
        {navMenuOpen && (
          <MobileNavMenu
            menuOpen={navMenuOpen}
            onClose={() => setNavMenuOpen(false)}
            userPermissions={userPermissions}
          />
        )}
      </Box>
    </>
  )
}

interface MobileNavigationHeaderProps {
  onNavMenuClick: () => void
}

const MobileNavigationHeader = ({
  onNavMenuClick,
}: MobileNavigationHeaderProps) => {
  const navigate = useNavigate()

  return (
    <Box className={styles.MobileNavHeader}>
      <Box className={styles.mobileNavLeft}>
        <MenuIcon
          sx={{
            marginRight: '10px',
            cursor: 'pointer',
          }}
          onClick={onNavMenuClick}
        />
        <HomepageLogo href="/" />
      </Box>
      <Button
        variant="text"
        className={sharedStyles.login}
        onClick={() => navigate('/logout')}
      >
        <Typography variant="body1">Logout</Typography>
      </Button>
    </Box>
  )
}

export default MobileNavigation
